import apiService from './apiService';

/**
 * Service pour la gestion des utilisateurs
 */
class UserService {
  /**
   * Récupère la liste des utilisateurs avec filtres
   * @param {Object} params - Paramètres de recherche (search, paginate, orderby, order)
   */
  async getUsers(params = {}) {
    const response = await apiService.get('/users', params);
    return response.data;
  }

  /**
   * Récupère un utilisateur spécifique
   * @param {string} id - ID de l'utilisateur
   */
  async getUser(id) {
    const response = await apiService.get(`/users/${id}`);
    return response.data;
  }

  /**
   * Crée un nouvel utilisateur
   * @param {Object} userData - Données de l'utilisateur
   */
  async createUser(userData) {
    // Préparer les données avec FormData si avatar présent
    if (userData.avatar instanceof File) {
      const formData = new FormData();
      Object.keys(userData).forEach(key => {
        if (key === 'person' && typeof userData[key] === 'object') {
          formData.append(key, JSON.stringify(userData[key]));
        } else if (userData[key] !== null && userData[key] !== undefined) {
          formData.append(key, userData[key]);
        }
      });
      const response = await apiService.upload('/users', formData);
      return response.data;
    }
    
    const response = await apiService.post('/users', userData);
    return response.data;
  }

  /**
   * Met à jour un utilisateur
   * @param {string} id - ID de l'utilisateur
   * @param {Object} userData - Nouvelles données
   */
  async updateUser(id, userData) {
    // Préparer les données avec FormData si avatar présent
    if (userData.avatar instanceof File) {
      const formData = new FormData();
      Object.keys(userData).forEach(key => {
        if (key === 'person' && typeof userData[key] === 'object') {
          formData.append(key, JSON.stringify(userData[key]));
        } else if (userData[key] !== null && userData[key] !== undefined) {
          formData.append(key, userData[key]);
        }
      });
      const response = await apiService.putFormData(`/users/${id}`, formData);
      return response.data;
    }
    
    const response = await apiService.put(`/users/${id}`, userData);
    return response.data;
  }

  /**
   * Supprime un utilisateur
   * @param {string} id - ID de l'utilisateur
   */
  async deleteUser(id) {
    return apiService.delete(`/users/${id}`);
  }

  /**
   * Récupère le profil de l'utilisateur connecté
   */
  async getProfile() {
    const response = await apiService.get('/users/profile');
    return response.data;
  }

  /**
   * Met à jour le profil de l'utilisateur connecté
   * @param {Object} profileData - Nouvelles données du profil
   */
  async updateProfile(profileData) {
    const response = await apiService.put('/users/profile', profileData);
    return response.data;
  }
}

const userServiceInstance = new UserService();
export default userServiceInstance;
